import { render, staticRenderFns } from "./ProgressBar.vue?vue&type=template&id=58166c50&scoped=true&"
import script from "./ProgressBar.vue?vue&type=script&lang=js&"
export * from "./ProgressBar.vue?vue&type=script&lang=js&"
import style0 from "./progress-bar.scss?vue&type=style&index=0&id=58166c50&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58166c50",
  null
  
)

export default component.exports